export const CourtsColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "court", headerName: "Court", flex: 1 },
];

export const CourtTypeColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "courtType", headerName: "Court Type", flex: 1 },
];

export const DocumentApproverColumns = [
  {field: "id", headerName: "ID", flex: 0.5},
  {field: "documentClassName", headerName: "DocumentClassName", flex: 1.5},
  {field: "documentTypeName", headerName: "DocumentTypeName", flex: 1.2},
  {field: "name", headerName: "ApproverName", flex: 1.2},
];

export const GenderColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "gender", headerName: "Gender", flex: 1 },
];

export const identificationTypeColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "identificationType", headerName: "identification Type", flex: 1 },
];

export const JudgesColumns = [
  { field: "judgeId", headerName: "ID", flex: 0.2 },
  { field: "name", headerName: "Judge Name", flex: 1 },
];

export const PhoneCodeColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "phoneCode", headerName: "Phone Code", flex: 1 },
];

export const TitlesColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "title", headerName: "Title", flex: 1 },
];
